module.exports = __webpack_public_path__ + "img/VOLVO TRUCKS.12949d7e.jpg";